import React, { useState } from "react";
import type { PriceType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import Price from "../../price/Price";
import * as Styles from "../styles/BasketItems";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";

type BasketItemWrapperType = {
    sectionTitleLabel: string;
    itemCount: number;
    totalPrice: PriceType;
    children: React.ReactNode;
    trackExpand: () => void;
};

const BasketItemWrapper = (props: BasketItemWrapperType): JSX.Element => {
    const { sectionTitleLabel, itemCount, totalPrice, children, trackExpand } = props;
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <>
            <Styles.HeaderToggle
                isCollapsible
                onClick={() => {
                    if (!isOpen) trackExpand();
                    setIsOpen(!isOpen);
                }}
            >
                <Styles.HeaderToggleInner isOpen={isOpen}>
                    <Styles.HeaderToggleTitle>
                        <Styles.ToggleIcon isDown={!isOpen}>
                            <Icon variant="chevronUp" />
                        </Styles.ToggleIcon>
                        <Styles.HeaderToggleTitle>
                            <Type.SmallHeading>{sectionTitleLabel}</Type.SmallHeading>
                            <Styles.Counter>{itemCount}</Styles.Counter>
                        </Styles.HeaderToggleTitle>
                    </Styles.HeaderToggleTitle>
                    <Styles.HeaderToggleDetails>
                        <Price price={totalPrice} />
                    </Styles.HeaderToggleDetails>
                </Styles.HeaderToggleInner>
            </Styles.HeaderToggle>
            {isOpen && <Styles.ContentWrapper>{children}</Styles.ContentWrapper>}
        </>
    );
};

export default BasketItemWrapper;
